import React, { FC } from 'react';
import { IListSearchFieldProps, ListSearchField } from '../../List/list-search-field.component';

type SearchInputProps = Omit<IListSearchFieldProps, 'mode'>;

const SearchInput: FC<SearchInputProps> = ({ sx = {}, onSearch, ...rest }) => (
  <ListSearchField sx={sx} onSearch={onSearch} mode="debounced" {...rest} />
);

export { SearchInput };
